module.exports = __webpack_public_path__ + "./images/ad8100a702761ddabda4cf543a6e9748.png";